import type { ReactNode } from 'react';

interface DropDownMenuProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  position?: 'right' | 'left';
  top?: string;
  right?: string;
  left?: string;
  minWidth?: string;
}

/**
 * DropDownMenu component with backdrop for closing
 * Provides a consistent dropdown menu design across the app
 */
function DropDownMenu({
  isOpen,
  onClose,
  children,
  position = 'right',
  top = '48px',
  right = '12px',
  left,
  minWidth = '176px'
}: DropDownMenuProps) {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 999
        }}
      />

      {/* Dropdown Menu */}
      <div
        style={{
          position: 'absolute',
          display: 'flex',
          flexDirection: 'column',
          gap: '2px',
          top,
          ...(position === 'right' ? { right } : {}),
          ...(position === 'left' ? { left } : {}),
          backgroundColor: 'white',
          borderRadius: 'var(--card-border-radius)',
          padding: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          zIndex: 1000,
          minWidth
        }}
      >
        {children}
      </div>
    </>
  );
}

export default DropDownMenu;
